import { render } from "./CenterBox.vue?vue&type=template&id=560c5a7e&scoped=true"
import script from "./CenterBox.vue?vue&type=script&lang=js"
export * from "./CenterBox.vue?vue&type=script&lang=js"

import "./CenterBox.vue?vue&type=style&index=0&id=560c5a7e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560c5a7e"]])

export default __exports__